import { render } from "./WebVideo.vue?vue&type=template&id=407b0452&ts=true"
import script from "./WebVideo.vue?vue&type=script&lang=ts"
export * from "./WebVideo.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__